import React, { useContext } from "react"
import { useAutoAnimate } from "@formkit/auto-animate/react"
import axios from "axios"
import { useState } from "react"
import Dropzone from "react-dropzone"
import { ERRORTYPES } from "../../config"
import { getEnvConfig } from "../../env"
import convertPDF2JPG from "../convertPDF/PDF2JPG"
import Alert from "../elements/Alert"
import Spinner from "../elements/Spinner"
import { getText } from "../strapi"
import { Context } from "../../store/store"
import Popup from "../elements/Popup"

const ReceiptUpload = ({}) => {
	const { globalState, dispatch } = useContext(Context)
	const env = getEnvConfig()

	const [showSample, setShowSample] = useState<boolean>(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<ERRORTYPES | null>()
	const [acceptedFile, setAcceptedFile] = useState<any>(null)

	const [receiptUploadRef] = useAutoAnimate<HTMLDivElement>()

	function onDrop(dropedFiles: any) {
		setLoading(true)
		if (dropedFiles.length > 0) {
			if (dropedFiles[0].size > 8000000) {
				// 8MB
				setError(ERRORTYPES.FILESIZE)
				setLoading(false)
				try {
					// eslint-disable-next-line
					let dataLayer = window["dataLayer"] || []
					dataLayer.push({ event: "form-submit", "form-name": "receipt", "form-submit": false, field_error: "upload_receipt" })
				} catch (e) {}
			} else {
				setError(null)

				setAcceptedFile(dropedFiles[0]) // TODO: check if this needs to be holded in the state???
				handleFileType(dropedFiles[0])
				setLoading(true)
			}
		} else {
			setError(ERRORTYPES.FILESIZE)
			setLoading(false)
			try {
				// eslint-disable-next-line
				let dataLayer = window["dataLayer"] || []
				dataLayer.push({ event: "form-submit", "form-name": "receipt", "form-submit": false, field_error: "upload_receipt" })
			} catch (e) {}
		}
	}

	function handleFileTypeError(error: any) {
		try {
			if (error.response.data.errors.errors[0] === "Participation with same receipt already exists.") {
				setError(ERRORTYPES.DOUBBLED)
			} else if (error.response.data.errors.errors[0] === "Reached maximum attempts with uploaded receipt.") {
				setError(ERRORTYPES.MAXTRIES)
			} else {
				setError(ERRORTYPES.RECEIPT_UPLOAD_ERROR)
			}
		} catch (error) {
			setError(ERRORTYPES.RECEIPT_UPLOAD_ERROR)
		}

		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "form-submit", "form-name": "receipt", "form-submit": false, field_error: "upload_receipt" })
		} catch (e) {}

		setLoading(false)
		setAcceptedFile(null)
	}

	function handleFileType(file) {
		setLoading(true)
		if (file.type !== "application/pdf") {
			uploadReceipt(file)
		} else {
			/* ✨ PDF magic ✨ */
			convertPDF2JPG(file)
				.then(file => {
					uploadReceipt(file)
				})
				.catch(error => {
					console.log("Error converting PDF to B64", error)
					setError(ERRORTYPES.RECEIPT_UPLOAD_ERROR)
					setLoading(false)
					try {
						// eslint-disable-next-line
						let dataLayer = window["dataLayer"] || []
						dataLayer.push({ event: "form-submit", "form-name": "receipt", "form-submit": false, field_error: "upload_receipt" })
					} catch (e) {}
				})
		}
	}

	async function uploadReceipt(file: any) {
		const env = getEnvConfig()
		const formdata = new FormData()
		formdata.append("file", file)
		axios
			.post(env.apibase + "uploadReceipt.php?cv=" + Date.now(), formdata, {
				headers: {
					"content-type": "multipart/form-data",
					Accept: "application/json",
				},
			})
			.then(res => {
				if (res.data.enqueued) {
					checkOCRStatus(res.data.temporaryReceiptDataId)
					try {
						// eslint-disable-next-line
						let dataLayer = window["dataLayer"] || []
						dataLayer.push({ event: "receipt", "receipt-upload": "upload-successful" })
					} catch (e) {}
				} else {
					console.log("NoSuc", env.apibase, res.data)
					handleFileTypeError(new Error("File submitted but something's wrong 🤔: " + JSON.stringify(res)))
					try {
						// eslint-disable-next-line
						let dataLayer = window["dataLayer"] || []
						dataLayer.push({ event: "form-submit", "form-name": "receipt", "form-submit": false, field_error: "upload_receipt" })
					} catch (e) {}
				}
			})
			.catch(error => {
				console.log("Err", error)
				handleFileTypeError(error)
				setAcceptedFile(null)
			})
	}

	async function checkOCRStatus(reference: string, maxTries: number = 30) {
		axios
			.get(env.apibase + "checkReceiptUploadStatus.php?reference=" + reference + "&cv=" + Date.now())
			.then(res => {
				if (!!res.data.gptPassed) {
					// Process succeeded

					if (res.data.gptProcessed) {
						dispatch({
							type: "SET_RECEIPT_REFERENCE",
							receiptReference: reference,
							receiptFileName: res.data.processedFileName,
						})
						try {
							// eslint-disable-next-line
							let dataLayer = window["dataLayer"] || []
							dataLayer.push({ event: "form-submit", "form-name": "receipt", "form-submit": true })
						} catch (e) {}
					} else {
						setError(ERRORTYPES.RECEIPT_UPLOAD_ERROR)
						setAcceptedFile(null)
					}

					setLoading(false)
				} else {
					maxTries--
					if (maxTries === 0) {
						setError(ERRORTYPES.RECEIPT_UPLOAD_ERROR)
						setLoading(false)

						console.log(new Error("Too many attempts!"))
						setAcceptedFile(null)

						try {
							// eslint-disable-next-line
							let dataLayer = window["dataLayer"] || []
							dataLayer.push({ event: "form-submit", "form-name": "receipt", "form-submit": false, field_error: "upload_receipt" })
						} catch (e) {}
					} else {
						setTimeout(() => checkOCRStatus(reference, maxTries), 3000)
					}
				}
			})
			.catch(error => {
				setError(ERRORTYPES.RECEIPT_UPLOAD_ERROR)
				setAcceptedFile(null)
				try {
					// eslint-disable-next-line
					let dataLayer = window["dataLayer"] || []
					dataLayer.push({ event: "form-submit", "form-name": "receipt", "form-submit": false, field_error: "upload_receipt" })
				} catch (e) {}
			})
	}

	return (
		<>
			<Dropzone onDrop={onDrop} multiple={false} accept="image/jpeg,image/png,application/pdf">
				{({ getRootProps, getInputProps }) => (
					<section ref={receiptUploadRef} className=" lg:mx-8 pt-[2.2rem] sm:pt-[3.2rem]">
						{!loading ? (
							<div className="border-1 flex  flex-col border-white" {...getRootProps()}>
								<input type="file" accept="image/jpeg,image/png,application/pdf" {...getInputProps()} />

								{acceptedFile ? (
									<>
										<div className="relative">
											<span className="block w-[100%] text-center font-AmsiRegular text-[25px] uppercase text-blue lg:inline-block lg:w-[auto] ">
												<img src={process.env.PUBLIC_URL + "/images/ico-uploaded.svg"} alt="" className="mx-auto mb-4 w-[96px] " />
												<strong className="text-green font-AmsiBlack ">Kaufbeleg erfolgreich hochgeladen</strong>
												<p className="bg-blue/25 rounded-lg px-4 py-2 mt-2 mb-2">{acceptedFile.name}</p>
											</span>
										</div>
									</>
								) : (
									<div className="relative">
										{error ? (
											<>
												<span className="block w-[100%] text-center font-AmsiRegular text-[25px]   text-errorred lg:inline-block lg:w-[auto] ">
													<img src={process.env.PUBLIC_URL + "/images/upload_error.png"} alt="" className="mx-auto mb-4 w-[96px] " />
												
												</span>
											</>
										) : (
											<>
												<span className="block w-[100%] text-center font-AmsiRegular text-[25px]   text-green lg:inline-block lg:w-[auto] ">
													<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-4">
														<path d="M8 29.333C8 34.3613 8 36.8754 9.5621 38.4375C11.1242 39.9997 13.6383 39.9997 18.6667 39.9997H29.3333C34.3616 39.9997 36.8757 39.9997 38.4379 38.4375C40 36.8754 40 34.3613 40 29.333" stroke="#002F42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
														<path d="M24 31.1111V8M16.8889 15.7778L24 8L31.1111 15.7778" stroke="#002F42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
													</svg>


													<strong className="text-blue font-AmsiRegular text-[21px] sm:text-[24px] leading-tight">
														Kaufbeleg hier ablegen oder durchsuchen <span className="cursor-pointer underline" onClick={(e) => { e.preventDefault(); setShowSample(true); }}>
															
															</span>
													</strong>
												</span>
											</>
										)}
									</div>
								)}
							</div>
						) : (
							<div className="flex flex-col items-center" {...getRootProps()}>
								<span className="font-Roboto block w-[100%] rounded   px-12 text-center text-[42px]   text-errorred lg:inline-block lg:w-[auto]  ">
									<strong>
										<Spinner />
									</strong>
								</span>
							</div>
						)}
						{error && <Alert className={" max-w-[60%] md:max-w-[30%] mx-auto font-AmsiBlack text-[16px] md:text-[22px] text-left"}>{error}</Alert>}
					</section>
				)}
			</Dropzone>
			<div className="mx-auto  pb-4 text-center lg:pb-8">
				<div className="pointer-events-none relative  text-center text-[14px] sm:text-[17px] pt-2 font-AmsiRegular text-blue">
					Unterstützte Dateiformate:<br/> JPG, PNG, PDF, max. 8 MB
				</div>
			</div>
			<div ref={animationRef}>
				{showSample && (
					<Popup close={() => setShowSample(false)}>
						<img src={process.env.PUBLIC_URL + "/images/kassenbon-beispiel-mobile.jpg"} alt="Kassenbon Beispiel" className="mx-auto block max-h-[80vh] w-auto lg:hidden" />
						<img src={process.env.PUBLIC_URL + "/images/kassenbon-beispiel.jpg"} alt="Kassenbon Beispiel" className="mx-auto hidden max-h-[80vh] w-auto lg:block" />
					</Popup>
				)}
			</div>
		</>
	)
}

export default ReceiptUpload
